"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = "\n  cid \n  name\n  tracking {\n    token\n  }\n  topsellerProduct {\n      image\n      pid\n  }\n";
//# sourceMappingURL=categoryData.js.map